/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const jsonRegexp = /\{.*:.*\}/g;
export const dollarAndLettersRegexp = /\$[a-zA-Z]+/g;
export const functionRegexp = /[a-zA-Z]+\([0-9]*\)/g;
export const equalRegexp = /[=]{2,}/g;
export const differentRegexp = /!=/g;
export const andRegexp = /[&]{2,}/g;
export const orRegexp = /[|]{2,}/g;
export const emailRegexp = /\S+@\S+\.\S+/;
